import TargetCustomerType from "@/models/Products/TargetCustomerType";

export default (targetCustomerType: TargetCustomerType) => {
    let returnVal = "Undefined";
    switch (targetCustomerType) {
        case TargetCustomerType.Retail:
            returnVal = "Retail"
            break;
        case TargetCustomerType.Commercial:
            returnVal = "Commercial"
            break;
    }
    return returnVal;
}